// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  apiUrl: 'https://essapi.azatecon.com/',
    fresh_work_api: 'https://azateconcss.myfreshworks.com/login/auth/1727161439554?client_id=451979510707337272&redirect_uri=https%3A%2F%2Fazatecon6354894596173193.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback%3Fhd%3Dazatecon6354894596173193.freshdesk.com',
  firebaseConfig : {
  apiKey: "AIzaSyDDiP35QpJwsMwvBUXYeUMQxrBtZfD0efE",
  authDomain: "azatecon-3b631.firebaseapp.com",
  projectId: "azatecon-3b631",
  storageBucket: "azatecon-3b631.firebasestorage.app",
  messagingSenderId: "543784324609",
  appId: "1:543784324609:web:db3c12da5c9e23cfd03a00",
  vapidKey:"BK27UBMTu5NEvsuGPuKOi-q9LVH8EATck5OTsakVr6rfKB3EgS7XSWy_RFMHesKQKz8lSbUVxdIpn9Asr7tgr50"
}


};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
